export enum MapObjectExportCadUnits {
    Kilometres = "Kilometres",
    Metres = "Metres",
    Centimetres = "Centimetres",
    Millimetres = "Millimetres",
    Feet = "Feet",
    Inches = "Inches"
}